import { render } from "./CardCompliance.vue?vue&type=template&id=3147e0c8"
import script from "./CardCompliance.vue?vue&type=script&lang=js"
export * from "./CardCompliance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__